import { TextInput } from "app/components/FormInputs/FormInputs";
import "./WithdrawalTextInput.scss";

type Props = {
  id: string;
  label: string;
  handleChange: Function;
  errorMessage: string;
  required?: boolean;
  type?: string;
  handleBlur: (id: string, value: string) => void;
};
export const WithdrawalTextInput = (props: Props) => {
  const { id, label, handleChange, errorMessage, required, type } = props;
  const handleBlur = (id: string, value: string) => {
    props.handleBlur(id, value);
  };
  return (
    <div className={"withdrawal-text-input"} key={id}>
      <TextInput
        type={type ? type : "text"}
        id={id}
        label={label}
        onChange={handleChange}
        className="WithdrawalTextInput"
        removeDefaultStyle={false}
        inlineLabel={true}
        handleBlur={(id: string, e: { target: { value: string } }) => {
          handleBlur(id, e.target.value);
        }}
        required={required}
      />
      <div className="error-msg">{errorMessage}</div>
    </div>
  );
};
